import Vue from 'vue';
import VueRouter from 'vue-router';
import VueMeta from 'vue-meta'

import ExibirLegislacaoModal from './views/legislacoes/ExibirLegislacaoModal.vue';
import LegislacoesIndexView from './views/legislacoes/LegislacoesIndexView.vue';
import SobreView from './views/SobreView.vue';
import NaoEncontrado from './views/NaoEncontrado.vue';

Vue.use(VueRouter);
Vue.use(VueMeta);

const routes = [
    {
        path: "/",
        name: 'IndexLegislacao',
        component: LegislacoesIndexView,
        props: true,
        children: [
            {
                path: '/legislacoes/:id/:slug?',
                name: 'exibirLegislacao',
                component: ExibirLegislacaoModal,
                props: true,
            },
        ]
    },
    {
        path: '/sobre',
        name: 'Sobre',
        component: SobreView,
        props: true,
    },
    {
        name: 'NaoEncontrado',
        path: '/nao-encontrado',
        component: NaoEncontrado
    },
    {
        path: '/sessoes/autenticar',
        redirect: to => {
            return { name: 'IndexLegislacao', query: { url: to.path }}
        }
    },
    {
        path: '*',
        redirect: to => {
            return { name: 'NaoEncontrado', query: { url: to.path }}
        }
    }
];

const router = new VueRouter({
    routes,
    mode: 'history'
});

// Bloqueio de acesso aos cards durante suspensão eleitoral
router.beforeEach((to, from, next) => {
    // Redireciona qualquer tentativa de acesso à página de legislação individual
    if (to.name === 'exibirLegislacao') {
        next({ name: 'IndexLegislacao' });
    } else {
        next();
    }
});

export default router;